
<!-- 设置默认屏显 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "../../commonStructure.vue"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
      return {
        requestBody: {
          "parkCode": "PR2WCYG4",
          "deviceType": 0,
          "channelCode": "3571F003",
          "templateId": 0,
          "templateData": {
            "imageArray": [{
              "sequence": 1,
              "content": "http://127.0.0.1:8080/screen1.jpg"
            }]
          }
        },
        responseCode: {
          "data": {
          }, "message": "业务成功", "resultCode": 0, "status": 1
        },
        infoData: {
          explain: "第三方接入系统请求智慧停车开放平台对通道绑定的屏显下发默认显示内容。",
          t_url: this.commonUrls.test+"setDefaultScreen",
          p_url: this.commonUrls.prod+"setDefaultScreen",
          precondition: "",
          fitSystem: "云停车场，VEMS传统停车场",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
              { info1: 'deviceType', info2: '是', info3: 'Integer', info4: '设备类型，0：一体机；1：智慧岗亭' },
              { info1: 'channelCode', info2: '是', info3: 'String', info4: '通道自定义编码' },
              { info1: 'templateId', info2: '否', info3: 'Integer', info4: '模板id，默认0，目前仅支持0' },
              { info1: 'templateData', info2: '是', info3: 'JSONObject', info4: '屏显内容' },
            ]
          }, {
            tableDataName: '模板0',
            tableType: 'screen',
            titleName: 'templateData',
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'text', info2: '否', info3: 'JSONArray', info4: '文字内容' },
              { info1: 'imageArray', info2: '是', info3: 'JSONArray', info4: '显示的图片数组，最多10张' },
            ],
            brother: [{
              titleName: 'imageArray（模板0，图片轮播时间间隔为5秒）',
              tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
              td: [
                { info1: 'sequence', info2: '是', info3: 'Integer', info4: '显示的顺序，从1开始，最大10' },
                { info1: 'time', info2: '否', info3: 'Integer', info4: '显示时长，单位：秒' },
                { info1: 'content', info2: '是', info3: 'String', info4: '内容，base64或者图片的公网地址（http开头），支持格式：jpg；建议不超过300kb。注意： 当设备为一体机时图片尺寸为1080(宽)*1920(高)；当设备为智慧岗亭时图片尺寸为 764(宽)*1024(高)；如清楚显示屏为led屏时图片比例为1:1' },
              ]
            },
              {
                titleName: 'text',
                tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                td: [
                  { info1: 'line', info2: '是', info3: 'Integer', info4: '行号，从1开始，最大2' },
                  { info1: 'color', info2: '是', info3: 'String', info4: '文字颜色，格式:"#FF0000"' },
                  { info1: 'content', info2: '否', info3: 'String', info4: '内容' },
                ]
              },
              ]
          },
            ],
          R_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
            ]
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
            td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/hidden/setDefaultScreenSelf.vue